import { render, staticRenderFns } from "./voluntarilyPrint.vue?vue&type=template&id=4ddb6ed6&scoped=true"
import script from "./voluntarilyPrint.vue?vue&type=script&lang=js"
export * from "./voluntarilyPrint.vue?vue&type=script&lang=js"
import style0 from "./voluntarilyPrint.vue?vue&type=style&index=0&id=4ddb6ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb6ed6",
  null
  
)

export default component.exports